import React from 'react';
import { Box, Tooltip, IconButton, useMediaQuery } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos, HelpOutline } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const logoData = [
  {
    type: 'img',
    src: require('../../../assets/logos/tech/metatrader-4.png'),
    alt: 'MetaTrader 4',
    tooltip: 'MetaTrader 4',
  },
  {
    type: 'img',
    src: require('../../../assets/logos/tech/metatrader-5.png'),
    alt: 'MetaTrader 5',
    tooltip: 'MetaTrader 5',
  },
  {
    type: 'img',
    src: require('../../../assets/logos/tech/cqg.png'),
    alt: 'CQG',
    tooltip: 'CQG',
  },
  {
    type: 'img',
    src: require('../../../assets/logos/tech/finalto.jpg'),
    alt: 'Finalto',
    tooltip: 'Finalto',
  },
  {
    type: 'img',
    src: require('../../../assets/logos/tech/integral.png'),
    alt: 'Integral',
    tooltip: 'Integral',
  },
  {
    type: 'img',
    src: require('../../../assets/logos/tech/interactive-brookers.png'),
    alt: 'Interactive Brokers',
    tooltip: 'Interactive Brokers',
  },
];

const AboutLogosRow = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const scrollRef = React.useRef(null);
  // Scroll by one logo width
  const scrollBy = (dir) => {
    if (scrollRef.current) {
      const logoWidth = 72 + 16; // width + gap (px)
      scrollRef.current.scrollBy({ left: dir * logoWidth, behavior: 'smooth' });
    }
  };
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 5 }}>
      {isMobile && (
        <IconButton aria-label="Scroll left" onClick={() => scrollBy(-1)}>
          <ArrowBackIos fontSize="small" />
        </IconButton>
      )}
      <Box
        ref={scrollRef}
        sx={{
          display: 'flex',
          gap: { xs: 2, sm: 4 },
          overflowX: isMobile ? 'auto' : 'visible',
          justifyContent: isMobile ? 'flex-start' : 'center',
          alignItems: 'center',
          scrollBehavior: 'smooth',
          maxWidth: isMobile ? '80vw' : 'none',
        }}
      >
        {logoData.map((logo, idx) => (
          <Tooltip title={logo.tooltip} key={idx} arrow>
            {logo.type === 'img' ? (
              <Box
                component="img"
                src={logo.src}
                alt={logo.alt}
                sx={{
                  width: { xs: 64, sm: 88 },
                  height: { xs: 64, sm: 88 },
                  borderRadius: '50%',
                  objectFit: 'cover',
                  boxShadow: 3,
                  background: 'transparent',
                  transition: 'box-shadow 0.2s, transform 0.2s',
                  '&:hover': {
                    boxShadow: 6,
                    transform: 'scale(1.08)',
                  },
                }}
                draggable={false}
              />
            ) : (
              <Box
                sx={{
                  width: { xs: 64, sm: 88 },
                  height: { xs: 64, sm: 88 },
                  borderRadius: '50%',
                  background: theme.palette.grey[300],
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: 3,
                  transition: 'box-shadow 0.2s, transform 0.2s',
                  fontSize: { xs: 36, sm: 48 },
                  color: theme.palette.grey[600],
                  '&:hover': {
                    boxShadow: 6,
                    transform: 'scale(1.08)',
                  },
                }}
              >
                <HelpOutline fontSize="inherit" />
              </Box>
            )}
          </Tooltip>
        ))}
      </Box>
      {isMobile && (
        <IconButton aria-label="Scroll right" onClick={() => scrollBy(1)}>
          <ArrowForwardIos fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default AboutLogosRow;
